import { Box, StackProps, Text, VStack } from "@chakra-ui/react";

interface Props extends StackProps {
  title?: string;
  subtitle?: string;
  size?: string;
}

export const SpinnerLoading = ({
  title = "Menyiapkan",
  subtitle = "Tunggu sebentar kami sedang menyiapkan untuk anda",
  size = "xl",
  ...rest
}: Props) => {
  return (
    <VStack w={"full"} h={"full"} p={8} gap={0} {...rest}>
      <Box className="spinner-loader" />

      <Text textStyle={"b-reg-sb"} mt={4}>
        {title}
      </Text>

      <Text textStyle={"b-sm"} textAlign={"center"} variant={"secondary"}>
        {subtitle}
      </Text>
    </VStack>
  );
};
